import { useParams, useSearchParams } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs";
import { useEffect, useState } from "react";
import { CharityIssueCategory } from "../../../models";
import NotFound from "../../../components/not-found";
import CharityIssueCategoryService from "../../../services/CharityIssueCategoryService";
import CharityIssueCategoryEditForm from "./ui/charity-issue-category-edit-form";
import CharityIssueCategorySkeleton from "./skeletons/charity-issue-category-skeleton";
import CharityIssuesTable from "./ui/charity-issues-table";
import { CharityIssueCategoryViewModel } from "../../../viewModels";

export default function CharityIssueCategoryEditPage() {
  const [searchParams] = useSearchParams();

  const { id } = useParams<{ id: string }>();
  const [category, setCategory] = useState<CharityIssueCategoryViewModel | null>(
    null
  );
  const [loading, setLoading] = useState(true);
  const api = new CharityIssueCategoryService();

  useEffect(() => {
    if (id) {
      api
        .getCharityIssueCategory(id)
        .then((data) => {
          setCategory(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [id, searchParams.get("reload")]);

  if (!loading && !category)
    return (
      <NotFound
        message="Category not found."
        backUrl="/admin/charity-issue-categories"
      ></NotFound>
    );

  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Charity Issue Categories", href: "/admin/charity-issue-categories" },
          {
            label: "Edit",
            href: `/admin/charity-issue-categories/edit/${id}`,
            active: true,
          },
        ]}
      />
      {loading ? <CharityIssueCategorySkeleton /> : null}

      {!loading && category ? (
        <>
          <CharityIssueCategoryEditForm category={category} />
          <CharityIssuesTable category={category}></CharityIssuesTable>
        </>
      ) : null}
    </main>
  );
}
